export default function ClientInfoTabs({ activeTab, onTabChange }) {
    const tabs = ['General Information', 'Documents', 'Invoices']
    
    return (
      <div className="md:border-b mb-3 md:mb-6">
        <div className="flex gap-4 md:gap-8">
          {tabs.map((tab) => (
            <button
              key={tab}
              className={`px-1 pt-4 text-sm font-medium border-b-2 transition-colors ${
                activeTab === tab
                  ? 'border-black '
                  : 'border-transparent'
              }`}
              onClick={() => onTabChange(tab)}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>
    )
  }
  
  